import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Checkboxes } from '../../../FlowConfigurationInputs';
import AutomService from '../../../../services/AutomService/AutomService';
import VariableService from '../../../../services/VariableService/VariableService'
import { MenuItem, Select } from '@material-ui/core';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function AutomFlow({ action, variables, setOpenVariable, showAlert, findElementName, getAutomNamesIDs }) {
    const { t } = useTranslation();
    const [automs, setAutoms] = useState([]);
    const label = 'CONTENT.CONFIGURATION-FORM.AUTOMS.AUTOMFLOW.';
    const options = {
        dropdown: { data: automs, defaultValue: '' },
        checkboxes: { label: label + 'HIDDEN' }
    }
    const [selectedAutom, setSelectedAutom] = useState('');
    const [automVariables, setVariables] = useState({ inputs: [], outputs: [] });

    useEffect(() => {
        fetchData();
    }, [action]);

    const fetchData = async () => {
        const response = await AutomService.getAllAutoms();
        if (response?.status) {
            let data = [];
            for (const autom of response.data) {
                if (autom.type === 'Autom') {
                    data.push({ label: autom.name, value: autom.id });
                }
            }
            setAutoms(data);
        }
        if (!action.fields.autom) { action.fields.autom = { value: '' }; setSelectedAutom(''); }
        else { handleChangeAutom(action.fields.autom.value, true); }
    };

    const fetchVariables = async (value, change) => {
        let inputs = [], outputs = [];
        let response = await VariableService.getVariable(value);
        if (response?.status) {
            for (const item of response.data) {
                if (item.is_output === 1) {
                    outputs.push(item);
                }
                if (item.is_input === 1) {
                    inputs.push(item);
                }
            }
            if (!change && action.fields.inputs !== inputs) {
                action.fields.inputs = inputs;
            }
            if (!change && action.fields.outputs !== outputs) {
                action.fields.outputs = outputs;
            }
            setVariables({ inputs, outputs });
        }
    }

    const handleBlur = (event) => {
        if (findElementName(event.target.outerText)) {
            showAlert(t(label + 'SAME-NAME'));
        }
    }

    const handleChangeAutom = (value, change) => {
        setSelectedAutom(value);
        fetchVariables(value, change);
    }

    const handleChange = (event) => {
        action.fields.autom.value = event.target.value;
        handleChangeAutom(event.target.value);
    }

    return (
        <div>
            <div className="form-element">
                {t(label + 'NAME')}
                <TextInput action={action} inputName="elementName"
                    variables={variables} setOpenVariable={setOpenVariable}
                    onBlur={handleBlur}
                />
            </div>
            <div className="form-element" style={{ width: "90%" }}>
                {t(label + 'CHOOSE')}
                {/* <Dropdown action={action} inputName="autom" options={options.dropdown}/> */}
                <Select value={selectedAutom} onChange={handleChange} variant="outlined" fullWidth>
                    {automs.map((item, itemI) => <MenuItem key={itemI} value={item.value}>{item.label}</MenuItem>)}
                </Select>
            </div>
            {selectedAutom !== '' &&
                <div>
                    {automVariables.inputs.length > 0 ? <div style={{ fontSize: 12, fontWeight: 700 }}>{t(label + 'INPUTS')}</div>
                        :
                        <div style={{ fontSize: "12px", fontWeight: 700, color: "#C4C4C4" }}>{t(label + 'NO-INPUT')}</div>}
                    {automVariables.inputs.map((item, itemI) =>
                        <div key={itemI} className="form-element sub-element">
                            {item.name}
                            <TextInput action={action.fields.inputs} inputName={itemI}
                                variableType={item.type} variables={variables} />
                        </div>
                    )}
                    {automVariables.outputs.length > 0 && <div style={{ fontSize: 12, fontWeight: 700 }}>{t(label + 'OUTPUTS')}</div>}
                    {automVariables.outputs.map((item, itemI) =>
                        <div key={itemI} className="form-element sub-element">
                            {item.name}
                            <VariablePicker action={action.fields.outputs} inputIndex={itemI}
                                variableType={item.type} showAlert={showAlert} setOpenVariable={setOpenVariable}
                                getAutomNamesIDs={getAutomNamesIDs} variables={variables} />
                        </div>
                    )}
                </div>
            }
            <div className="form-element">
                <Checkboxes action={action} inputName="hidden" options={options.checkboxes} />
            </div>
        </div>
    );
}
export default AutomFlow;